export default {
    drag_and_drop: 'Prevucite ovde i spustite vaše slike ili',
    browse_files: 'Pronađite slike',
    your_uploads: 'Učitane slike',
    allowed_types: 'Dozvoljeni tipovi: .png .jpg .jpeg',
    wrong_file_type: 'Neki od vaših fajlova ima pogrešan tip. \n Dozvoljeni tipovi: .png .jpg .jpeg',
    max_number: 'Najveći broj slika koje možete izabrati je: {n}',
    files_over_limit: 'Maksimalni limit po slici je: {n}MB',
    add_image_here: 'Dodajte sliku ovde',
    cant_delete_main_image: 'Glavna slika se ne može ukloniti. Izaberite drugu sliku kao glavnu da biste mogli ukloniti ovu.',
    set_main: 'Postavi kao glavnu',
    invalid_image: 'Neke od vaših slika nisu validne. One neće biti uploadovane!',
    invalid_file: 'Slika nije validna',
}
